import { Outlet } from 'react-router-dom';
import TopBar from '@/components/ui/topBar/TopBar';

export function AppLayout() {
  return (
    <div className="gradient-shell flex h-full w-full rounded-xl p-2">
      <div className="flex w-full flex-col gap-2">
        <TopBar />
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AppLayout;
